import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { isExchangeUrl } from './consent.model';
import { ConsentService } from './consent.service';

/**
 * Appends gdpr, gdpr_consent, us_privacy, gpp, and gpp_sid to outbound exchange
 * ad requests. Dashboard API calls are left alone — the exchange reads these
 * off the VAST/ad-request query string, not a consent header.
 */
@Injectable()
export class ConsentInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isExchangeUrl(request.url)) {
      return next.handle(request);
    }

    const url = this.injector.get(ConsentService).appendToUrl(request.url);
    if (url === request.url) {
      return next.handle(request);
    }
    return next.handle(request.clone({ url }));
  }
}
